import React, { useMemo } from "react";
import { Navigate, useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  SERVICE_CATALOG,
  getCatalogByCategorySlug,
  getCategoryTeaser,
  isCabBookingService,
  slugify
} from "./serviceCatalog";
import { useVBTranslation } from "./language";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";

const ServiceCategoryDetailsScreen = () => {
  const navigate = useNavigate();
  const { t } = useVBTranslation();
  const { categorySlug } = useParams();
  const [searchParams] = useSearchParams();

  const category = useMemo(
    () => getCatalogByCategorySlug(SERVICE_CATALOG, categorySlug),
    [categorySlug]
  );

  const selectedServiceSlug = searchParams.get("service");
  const selectedService = useMemo(() => {
    if (!category || !selectedServiceSlug) {
      return null;
    }
    return category.services.find((service) => slugify(service) === selectedServiceSlug) || null;
  }, [category, selectedServiceSlug]);

  if (!category) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="vb-page">
      <SiteHeader />

      <div className="vb-subheader">
        <button type="button" className="vb-secondary-btn" onClick={() => navigate(-1)}>
          {t("detailsBack")}
        </button>
      </div>

      <main className="vb-service-details-main">
        <section className="vb-service-details-hero">
          <h2>{category.category}</h2>
          <p>{getCategoryTeaser(category)}</p>
          <div className="vb-hero-pills">
            <span>{t("detailsPillServices", { count: category.services.length })}</span>
            <span>{t("detailsPillVerified")}</span>
            <span>{t("detailsPillFast")}</span>
          </div>
        </section>

        {selectedService && (
          <section className="vb-selected-service-card">
            <h3>{selectedService}</h3>
            <p>
              {t("detailsSupportText", { service: selectedService.toLowerCase() })}
            </p>
          </section>
        )}

        <section className="vb-details-grid" role="list" aria-label={`${category.category} services`}>
          {category.services.map((service) => (
            <article key={service} role="listitem" className="vb-details-item">
              <h4>{service}</h4>
              <p>
                {t("detailsServiceText", { service: service.toLowerCase() })}
              </p>
              <button
                type="button"
                className="vb-link-btn"
                onClick={() =>
                  isCabBookingService(category.category, service)
                    ? navigate("/cab-booking")
                    : navigate(`/services/${slugify(category.category)}/${slugify(service)}`)
                }
              >
                {t("detailsShowDetails")}
              </button>
            </article>
          ))}
        </section>
      </main>

      <SiteFooter />
    </div>
  );
};

export default ServiceCategoryDetailsScreen;
